import { debounce } from '../../../CodesThatsGottaGoSomewhereElse';
import { ActiveObject, resolve } from '../../Container';
import { EditorModeInfo } from '../EditorModeInfo';
import { EditorSession } from '../EditorSession';
import { GridSystem } from '../GridSystem';
import { ToolboxController } from '../tooling/ToolboxController';
import { ToolDefinition } from '../tooling/ToolDefinition';
import { ToolManager } from '../tooling/ToolManager';
import { WidgetManager } from '../workspace/widgets/WidgetManager';
import { DesignMode } from './DesignMode';
import { DesignModeWidget } from './DesignModeWidget';

const toolSelector = (x: ToolDefinition) =>
    x.category === 'design' || x.category === 'gestures' ||
    [
        'stickyTool',
        'indexCardTool',
        'taskCardTool',
        'roadmapCardTool',
        'tokenTool',
        'connectorTool',
        'markerTool',
        'reactionTool',
        'commentTool',
        'tagTool'
    ].includes(x.id);

export class DesignModeMechanics extends ActiveObject {

    @resolve(GridSystem) private readonly grid!: GridSystem;
    @resolve(EditorSession) private readonly session!: EditorSession;
    @resolve(ToolManager) private readonly tools!: ToolManager;
    @resolve(ToolboxController) private readonly toolbox!: ToolboxController;
    @resolve(WidgetManager) private readonly widgets!: WidgetManager;

    public start() {
        const syncDebounced = debounce(() => this.sync(), 0);
        this.burden(
            this.session.observe(EditorModeInfo, syncDebounced),
        );
        this.sync();
    }

    private sync = () => {
        const mode = this.session.get(EditorModeInfo);
        if (mode.id === DesignMode.id) {
            this.tools.setEnabled('*');
            this.tools.setVisible(
                this.toolbox.toArray().flatMap(x => x.tools).filter(toolSelector).map(x => x.id)
            );
            this.grid.configure({ enabled: true });
        }
        this.realizeWidget(mode.id === DesignMode.id);
    };

    private realizeWidget = (active?: boolean) => {
        const { widgets } = this;

        if (active && widgets.has('design')) return;

        widgets.delete('design');
        if (!active) return;

        const dock = widgets.createContainer({
            name: 'design',
            weight: 100,
            position: ['docked', 'bottom', 'inline'],
            style: 'none',
        });

        dock.add(widgets.createInline({
            ui: DesignModeWidget,
        }));

        widgets.add(dock);
    };
}
